import * as React from 'react';
import clsx from 'clsx';
import querystring from 'query-string';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { Backdrop, CircularProgress } from '@mui/material';

import { ReduxState } from 'ducks';
import { continueWithSigiraHandler } from 'lib/util/customer';
import { ApiKeyContext } from 'contexts/ApiKeyContext';

import styles from './MyPage.module.css';

export const SigiraSignIn = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const settings = useSelector((state: ReduxState) => state.server.settings.all);
  const { apiKey, useApiKeyInPaths } = React.useContext(ApiKeyContext);

  const [loading, setLoading] = React.useState(false);

  const afterAuthRedirectPath = React.useMemo(() => {
    if (router.query.afterAuthRedirectPath) {
      return decodeURIComponent(escape(atob(router.query.afterAuthRedirectPath as string)));
    }
    return null;
  }, [router.query.afterAuthRedirectPath]);

  const getRedirectPath = () => {
    let basePath = '/auth';
    if (useApiKeyInPaths) {
      basePath = `/${apiKey}${basePath}`;
    }
    return `${window.location.origin}${basePath}`;
  };

  const continueWithoutSignInHandler = () => {
    if (!afterAuthRedirectPath) {
      return;
    }
    setLoading(true);
    const parts = afterAuthRedirectPath.split('?');
    const path = parts[0];
    const query = parts[1];

    const params = querystring.parse(query);
    const newParams = params?.skipSignIn ? params : { ...params, skipSignIn: true };

    router.push({
      pathname: path,
      query: newParams,
    });
  };

  const loginForMemberLimitedProduct = router.query.memberLimitedProduct;

  return (
    <div id="login">
      <Backdrop open={loading} style={{ zIndex: 1 }}>
        <CircularProgress />
      </Backdrop>
      <div className={clsx(styles['box'], styles['box--880'])}>
        <div className={clsx(styles['sigira__login'])}>
          <div className={clsx(styles['sigira__section'])}>
            <p className={clsx(styles['ttl'], styles['ttl--large'])}>
              {t('Continue with SHIGIRA MEMBERS ID')}
            </p>
            <div className={clsx(styles['login__btns'], styles['sigira__login__btn'])}>
              <a
                className={clsx(styles['login__btns__item'], styles['gg'])}
                onClick={() => {
                  continueWithSigiraHandler(getRedirectPath(), afterAuthRedirectPath);
                }}
              >
                <div className={clsx(styles['sigira__logo'])}>
                  <img src="/static/images/sigira.svg" />
                </div>
                <p className={clsx(styles['sigira__color'])}>
                  {t('Continue with SHIGIRA MEMBERS ID')}
                </p>
              </a>
            </div>
          </div>
          {afterAuthRedirectPath &&
            !settings?.customer_ledger_settings?.customer_registration_required_for_booking &&
            !loginForMemberLimitedProduct && (
              <div className={clsx(styles['sigira__section'])}>
                <p className={clsx(styles['ttl'], styles['ttl--large'])}>
                  {t('If you do not have an account')}
                </p>
                <div className={clsx(styles['login__btns'], styles['sigira__nologin'])}>
                  <a
                    className={clsx(styles['btnMiddle'], styles['color--mainBor'])}
                    onClick={() => {
                      continueWithoutSignInHandler();
                    }}
                  >
                    {t('Continue reservation without login')}
                  </a>
                </div>
              </div>
            )}
        </div>
      </div>
      <p className={clsx(styles['provider'])}>{t('Memberships powered by NutmegLabs')}</p>
    </div>
  );
};
